import Vue from "vue";
import Vuex from "vuex";
import {
    calcTime,
    daysBetween,
    startHTTPRequest
} from "../../../assets/js/common";
import {
    CFG_NODE_API_BASE, CFG_WIDGET_URL_BASE
} from "../../../assets/js/config";
import { SUCCESS_COUPON_API, SUCCESS_HOME_API } from "../../types";

Vue.use(Vuex);

const getLiveStatus = (matches, limit, processStatus) => {
    let someMatches = (matches || []).slice(0, limit);
    if(processStatus) {
        return someMatches.map(match => {
            let current_date = new Date();
            let end_time = new Date(
                calcTime(new Date(match.end_date))
            );
            let ends_in = daysBetween(current_date, end_time, match.end_date);
    
            if(match.status == -2 && !ends_in.is_expired) {
                match.is_live_now = true;
            }
            return match;
        })
    } else {
        return someMatches;
    }
}

const home_store = {
    namespaced: true,
    state: () => ((typeof window !== "undefined" && window.__ROI_STATE_DATA__ && window.__ROI_STATE_DATA__.home_store) ? window.__ROI_STATE_DATA__.home_store : {
        page: 'home',
        trendingMatches: [],
        featuredMatches: [],
        teams: [],
        featuredContests: [],
        coupons: [],
        team_h2h: [],
        player_h2h: []
    }),
    actions: {
        fetchHomePageApi: ({ commit, state }) => {
            let actionData = {
                method: "GET",
                url: `${CFG_NODE_API_BASE}match-data/get-matches-data`,
                can_append: false
            };
            return startHTTPRequest(actionData)
                .then((res) => {
                    let { p_matches_json } = res || {};
                    commit(SUCCESS_HOME_API, p_matches_json);
                })
        },
        fetchHomePageCoupons: ({ commit }) => {
            let actionData = {
                method: "GET",
                url: `${CFG_WIDGET_URL_BASE}/static-assets/json-data/coupon_list.json`,
                can_append: false
            };
            return startHTTPRequest(actionData)
                .then((res) => {
                    commit('SUCCESS_COUPON_API', res);
                })
        }
    },
    mutations: {
        [SUCCESS_HOME_API]: (state, payload) => {
            let { trending_matches, featured_matches, lineup_matches, featured_contests, team_h2h, player_h2h} = payload || {};
            state.trendingMatches = getLiveStatus(trending_matches, 1);
            state.featuredMatches = getLiveStatus(featured_matches, 3, true);
            state.teams = getLiveStatus(lineup_matches, 3, true);
            state.featuredContests = getLiveStatus(featured_contests, 3);
            state.team_h2h = getLiveStatus(team_h2h, 3);
            state.player_h2h = getLiveStatus(player_h2h, 3);
        },
        [SUCCESS_COUPON_API]: (state, payload) => {
            state.coupons = payload;
        }

    }
}

export default home_store;